/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Preset_YearInputs */

const vi_report_preset_year = /** @type {(inputs: Report_Preset_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Năm nay`)
};

/**

* @param {Report_Preset_YearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_preset_year = /** @type {((inputs?: Report_Preset_YearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Preset_YearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_preset_year(inputs)
});